// Module
var code = `<table class="table">
  <thead>
    <th>No.</th>
    <th>Customer name</th>
    <th>Ownership type</th>
    <th>Birth Date</th>
    <th>Mother Branch</th>
    <th>Customer Number</th>
    <th ng-if="\$ctrl.editMode">Action</th>
  </thead>
  <tbody class="tbody">
  <tr ng-repeat="owner in \$ctrl.ownership">
    <td>{{\$index+1}}.</td>
    <td>
      {{owner.effectiveName}}
    </td>
    <td>
      <select type="select"
              disabled
              ng-model="owner.ownershipType"
              ng-options="o as o | translateEnum:'PRODUCT' for o in ['OWNER', 'SECONDARY_OWNER']">
      </select>
    </td>
    <td>
      {{owner.birthDate | prettyDate}}
    </td>
    <td>
      {{owner.branchName}}
    </td>
    <td>
      {{owner.customerNumber}}
    </td>
    <td ng-if="\$ctrl.editMode">
      <button type="button" class="btn btn-danger"
        ng-if="owner.ownershipType !== 'OWNER'"
        ng-click="\$ctrl.onRemoveOwner(\$index)">
        Remove
      </button>
    </td>
  </tr>
  <tr ng-if="\$ctrl.editMode">
    <td>{{\$ctrl.ownership.length + 1}}.</td>
    <td class="customer-picker" colspan="7">
      <customer-picker on-choose="\$ctrl.addOwner(customer, 'SECONDARY_OWNER')">
      </customer-picker>
    </td>
  </tr>
  </tbody>
</table>
<div class="clearfix"></div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/product-owners/product-owners.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;